(() => {
  const root = document.querySelector('[data-sj-support]');
  if (!root) return;
  if (root.dataset.sjSupportReady === 'true') return;
  root.dataset.sjSupportReady = 'true';

  const supportEmail = root.dataset.supportEmail || 'support@gambits.top';
  const copy = {
    en: {
      title: 'Atelier guide',
      subtitle: 'Basic guidance on Song Jin and made-to-order pieces.',
      greeting: 'Ask about Song Jin, product types, customization, care, making time, or launch shipping. Existing orders, payments, returns, and detailed requests are handled by email.',
      placeholder: 'Ask a basic question…',
      send: 'Send',
      open: 'Ask the atelier guide',
      close: 'Close',
      email: 'Email customer care',
      disclosure: 'AI guide · Do not share payment or sensitive personal information.',
      questions: ['What is Song Jin brocade?', 'How does customization work?', 'How long does making take?'],
      error: 'The guide is temporarily unavailable. Please email customer care.',
      contact: 'For order, payment, return, or detailed product questions, email customer care directly.',
      subject: 'Song Jin Atelier support',
    },
    ja: {
      title: '工房ガイド',
      subtitle: '宋錦とセミオーダーの基本的なご案内。',
      greeting: '宋錦、商品の種類、カスタム、お手入れ、制作期間、配送地域についてご質問ください。注文、支払い、返品、詳しいご相談はメールで承ります。',
      placeholder: '基本的な質問を入力…',
      send: '送信',
      open: '工房ガイドに質問',
      close: '閉じる',
      email: 'メールで問い合わせ',
      disclosure: 'AIガイド · 支払い情報や個人情報を入力しないでください。',
      questions: ['宋錦とは何ですか？', 'セミオーダーはどのように進みますか？', '制作にはどのくらいかかりますか？'],
      error: '現在、工房ガイドは応答できません。メールでお問い合わせください。',
      contact: '注文、支払い、返品、詳しい商品相談は、カスタマーケアへ直接メールでお問い合わせください。',
      subject: '宋錦アトリエ お問い合わせ',
    },
    'zh-CN': {
      title: '工坊顾问',
      subtitle: '回答宋锦与半定制的基础问题。',
      greeting: '可以询问宋锦知识、产品类型、半定制、保养、制作周期或配送范围。已有订单、支付、退换及复杂问题请通过邮件联系人工客服。',
      placeholder: '输入基础问题…',
      send: '发送',
      open: '询问工坊顾问',
      close: '关闭',
      email: '邮件联系人工客服',
      disclosure: 'AI 顾问 · 请勿发送付款信息或个人敏感信息。',
      questions: ['宋锦是什么？', '半定制是怎么做的？', '制作需要多长时间？'],
      error: '工坊顾问暂时无法回复，请通过邮件联系人工客服。',
      contact: '订单、支付、退换或复杂的产品问题，请直接邮件联系人工客服。',
      subject: '宋锦工坊客服咨询',
    },
  };

  const normalizeLocale = (value) => {
    if (/^zh/i.test(value || '')) return 'zh-CN';
    if (/^ja/i.test(value || '')) return 'ja';
    return 'en';
  };

  const toggle = root.querySelector('[data-sj-support-toggle]');
  const toggleText = root.querySelector('[data-sj-support-toggle-text]');
  const close = root.querySelector('[data-sj-support-close]');
  const panel = root.querySelector('[data-sj-support-panel]');
  const title = root.querySelector('[data-sj-support-title]');
  const subtitle = root.querySelector('[data-sj-support-subtitle]');
  const messages = root.querySelector('[data-sj-support-messages]');
  const form = root.querySelector('[data-sj-support-form]');
  const input = root.querySelector('[data-sj-support-input]');
  const submit = form.querySelector('button');
  const quick = root.querySelector('[data-sj-support-quick]');
  const disclosure = root.querySelector('[data-sj-support-disclosure]');
  const emailLink = root.querySelector('[data-sj-support-email-link]');
  const endpoint = root.dataset.endpoint;
  let locale = normalizeLocale(window.localStorage.getItem('songJinLanguage') || document.documentElement.lang);
  let greeted = false;
  let busy = false;

  const mailto = () => `mailto:${supportEmail}?subject=${encodeURIComponent(copy[locale].subject)}`;

  const addMessage = (text, role, options = {}) => {
    const item = document.createElement('div');
    item.className = `sj-support__message sj-support__message--${role}${options.loading ? ' sj-support__message--loading' : ''}`;
    item.textContent = text;
    if (options.handoff) {
      const link = document.createElement('a');
      link.className = 'sj-support__handoff';
      link.href = mailto();
      link.textContent = supportEmail;
      item.append(document.createElement('br'), link);
    }
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
    return item;
  };

  const updateContactEmail = (languageCopy) => {
    const block = document.querySelector('[data-sj-support-email-block]');
    if (!block) return;
    const text = block.querySelector('[data-sj-contact-email-copy]');
    const link = block.querySelector('a');
    if (text) text.textContent = languageCopy.contact;
    if (link) link.href = mailto();
  };

  const applyLocale = (value) => {
    locale = normalizeLocale(value);
    const languageCopy = copy[locale];
    root.dataset.locale = locale;
    toggleText.textContent = languageCopy.title;
    toggle.setAttribute('aria-label', languageCopy.open);
    toggle.title = languageCopy.open;
    panel.setAttribute('aria-label', languageCopy.title);
    title.textContent = languageCopy.title;
    subtitle.textContent = languageCopy.subtitle;
    close.setAttribute('aria-label', languageCopy.close);
    close.title = languageCopy.close;
    input.placeholder = languageCopy.placeholder;
    submit.setAttribute('aria-label', languageCopy.send);
    submit.title = languageCopy.send;
    disclosure.textContent = languageCopy.disclosure;
    emailLink.textContent = languageCopy.email;
    emailLink.href = mailto();
    quick.querySelectorAll('[data-sj-question]').forEach((button) => {
      const question = languageCopy.questions[Number(button.dataset.sjQuestion)] || languageCopy.questions[0];
      button.textContent = question;
      button.dataset.question = question;
    });
    updateContactEmail(languageCopy);

    if (greeted) {
      messages.replaceChildren();
      greeted = false;
      quick.hidden = false;
      if (!panel.hidden) {
        addMessage(languageCopy.greeting, 'guide');
        greeted = true;
      }
    }
  };

  const openPanel = () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (!greeted) {
      addMessage(copy[locale].greeting, 'guide');
      greeted = true;
    }
    window.requestAnimationFrame(() => input.focus());
  };

  const closePanel = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  };

  const ask = async (question) => {
    const clean = String(question || '').trim();
    if (!clean || busy) return;
    busy = true;
    input.value = '';
    input.disabled = true;
    submit.disabled = true;
    quick.hidden = true;
    addMessage(clean, 'user');
    const loading = addMessage('', 'guide', { loading: true });
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 20000);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: clean, locale }),
        signal: controller.signal,
      });
      const data = await response.json();
      if (!response.ok || !data.answer) throw new Error(data.error || 'support_error');
      loading.remove();
      addMessage(data.answer, 'guide', { handoff: Boolean(data.handoff) });
    } catch (error) {
      loading.remove();
      addMessage(copy[locale].error, 'guide', { handoff: true });
    } finally {
      window.clearTimeout(timer);
      busy = false;
      input.disabled = false;
      submit.disabled = false;
      input.focus();
    }
  };

  toggle.addEventListener('click', () => panel.hidden ? openPanel() : closePanel());
  close.addEventListener('click', closePanel);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    ask(input.value);
  });
  quick.querySelectorAll('[data-question]').forEach((button) => {
    button.addEventListener('click', () => ask(button.dataset.question));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });
  window.addEventListener('songjin:languagechange', (event) => applyLocale(event.detail?.locale));

  applyLocale(locale);
})();
